import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  toString22rbkbhdb5cl2 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Composer1pt8hwk95abxi as Composer,
  ComposerForUnquotedLiterals3v0rwxdudtla9 as ComposerForUnquotedLiterals,
  ComposerForUnsignedNumbers2h1dv6l9z3aef as ComposerForUnsignedNumbers,
} from './Composers.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  CLASS_getInstance25nhr3t715wdo as CLASS_getInstance,
  OBJECT_getInstance167untwb9admi as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClassDiscriminatorMode_NONE_getInstance39dg6hx0yqfbs as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  access$checkEncodingConflicts$tPolymorphicKt2migrcemidykb as access$checkEncodingConflicts$tPolymorphicKt,
  checkKind2e7hdnuk9c0tp as checkKind,
} from './Polymorphic.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import { SerializationStrategyh6ouydnm6hci as SerializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { switchMode35g725ikhjpwv as switchMode } from './WriteMode.mjs';
import { getJsonElementName36ciq3w3g8x0l as getJsonElementName } from './JsonNamesMap.mjs';
import { InvalidFloatingPointEncoded1h6zoomba5tnf as InvalidFloatingPointEncoded } from './JsonExceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from '../JsonEncoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf as get_jsonUnquotedLiteralDescriptor } from '../JsonElement.mjs';
import { Companion_getInstance1339zuieiizg3 as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  serializer3ikrxnm8b29d6 as serializer,
  serializer2lw83vwvpnyms as serializer_0,
  serializer36584sjyg5661 as serializer_1,
  serializer1q7c5q67ysppr as serializer_2,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstance2ln0tj1crqgxz as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstance2utgi65n0nnqj as Companion_getInstance_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance3rx8u2n07bmtm as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.v2s_1.y2q();
  $this.d1s(discriminator);
  $this.v2s_1.b2r(_Char___init__impl__6a9atx(58));
  $this.v2s_1.a2r();
  $this.d1s(serialName);
}
var StreamingJsonEncoderClass;
function StreamingJsonEncoder() {
  if (StreamingJsonEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static o2u(composer, json, mode, modeReuseCache) {
        var $this = this.r1r();
        $this.v2s_1 = composer;
        $this.w2s_1 = json;
        $this.x2s_1 = mode;
        $this.y2s_1 = modeReuseCache;
        $this.z2s_1 = $this.w2s_1.n1r();
        $this.a2t_1 = $this.w2s_1.a2m_1;
        $this.b2t_1 = false;
        $this.c2t_1 = null;
        $this.d2t_1 = null;
        var i = $this.x2s_1.w1_1;
        if (!($this.y2s_1 == null)) {
          if (!($this.y2s_1[i] === null) || !($this.y2s_1[i] === $this)) {
            $this.y2s_1[i] = $this;
          }
        }
        return $this;
      }
      f2o() {
        return this.w2s_1;
      }
      static e2t(output, json, mode, modeReuseCache) {
        return this.o2u(Composer(output, json), json, mode, modeReuseCache);
      }
      n1r() {
        return this.z2s_1;
      }
      w1s(descriptor, index) {
        return this.a2t_1.n2n_1;
      }
      r1s(serializer, value) {
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
          if (this.f2o().a2m_1.v2n_1) {
            serializer.i1m(this, value);
            break $l$block;
          }
          var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer();
          var tmp;
          if (isPolymorphicSerializer) {
            tmp = !this.f2o().a2m_1.d2o_1.equals(ClassDiscriminatorMode_NONE_getInstance());
          } else {
            var tmp_0;
            switch (this.f2o().a2m_1.d2o_1.w1_1) {
              case 0:
              case 2:
                tmp_0 = false;
                break;
              case 1:
                // Inline function 'kotlin.let' call

                var it = serializer.h1m().d1p();
                tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            tmp = tmp_0;
          }
          var needDiscriminator = tmp;
          var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.h1m(), this.f2o()) : null;
          var tmp_1;
          if (isPolymorphicSerializer) {
            var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (value == null) {
                var message = 'Value for serializer ' + toString_0(serializer.h1m()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
                throw IllegalArgumentException().n2(toString_0(message));
              } else {
                break $l$block_0;
              }
            }
            var actual = findPolymorphicSerializer(casted, this, value);
            tmp_1 = isInterface(actual, SerializationStrategy()) ? actual : THROW_CCE();
          } else {
            tmp_1 = serializer;
          }
          var actualSerializer = tmp_1;
          if (!(baseClassDiscriminator == null)) {
            access$checkEncodingConflicts$tPolymorphicKt(this.f2o(), serializer, actualSerializer, baseClassDiscriminator);
            checkKind(actualSerializer.h1m().d1p());
            var serialName = actualSerializer.h1m().k1n();
            this.c2t_1 = baseClassDiscriminator;
            this.d2t_1 = serialName;
          }
          actualSerializer.i1m(this, value);
        }
      }
      y1q(descriptor) {
        var newMode = switchMode(this.w2s_1, descriptor);
        if (!(newMode.h2u_1 === _Char___init__impl__6a9atx(0))) {
          this.v2s_1.b2r(newMode.h2u_1);
          this.v2s_1.w2q();
        }
        var discriminator = this.c2t_1;
        if (!(discriminator == null)) {
          var tmp0_elvis_lhs = this.d2t_1;
          encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.k1n() : tmp0_elvis_lhs);
          this.c2t_1 = null;
          this.d2t_1 = null;
        }
        if (this.x2s_1.equals(newMode)) {
          return this;
        }
        var tmp1_safe_receiver = this.y2s_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.w1_1];
        return tmp2_elvis_lhs == null ? StreamingJsonEncoder().o2u(this.v2s_1, this.w2s_1, newMode, this.y2s_1) : tmp2_elvis_lhs;
      }
      z1q(descriptor) {
        if (!(this.x2s_1.i2u_1 === _Char___init__impl__6a9atx(0))) {
          this.v2s_1.x2q();
          this.v2s_1.z2q();
          this.v2s_1.b2r(this.x2s_1.i2u_1);
        }
      }
      s1r(descriptor, index) {
        switch (this.x2s_1.w1_1) {
          case 1:
            if (!this.v2s_1.v2q_1) {
              this.v2s_1.b2r(_Char___init__impl__6a9atx(44));
            }

            this.v2s_1.y2q();
            break;
          case 2:
            if (!this.v2s_1.v2q_1) {
              var tmp = this;
              var tmp_0;
              if ((index % 2 | 0) === 0) {
                this.v2s_1.b2r(_Char___init__impl__6a9atx(44));
                this.v2s_1.y2q();
                tmp_0 = true;
              } else {
                this.v2s_1.b2r(_Char___init__impl__6a9atx(58));
                this.v2s_1.a2r();
                tmp_0 = false;
              }
              tmp.b2t_1 = tmp_0;
            } else {
              this.b2t_1 = true;
              this.v2s_1.y2q();
            }

            break;
          case 3:
            if (index === 0)
              this.b2t_1 = true;
            if (index === 1) {
              this.v2s_1.b2r(_Char___init__impl__6a9atx(44));
              this.v2s_1.a2r();
              this.b2t_1 = false;
            }

            break;
          default:
            if (!this.v2s_1.v2q_1) {
              this.v2s_1.b2r(_Char___init__impl__6a9atx(44));
            }

            this.v2s_1.y2q();
            this.d1s(getJsonElementName(descriptor, this.w2s_1, index));
            this.v2s_1.b2r(_Char___init__impl__6a9atx(58));
            this.v2s_1.a2r();
            break;
        }
        return true;
      }
      s1s(descriptor, index, serializer, value) {
        if (!(value == null) || this.a2t_1.s2n_1) {
          super.s1s(descriptor, index, serializer, value);
        }
      }
      f1s(descriptor) {
        var tmp;
        if (get_isUnsignedNumber(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_0;
          var tmp_1 = this.v2s_1;
          if (tmp_1 instanceof ComposerForUnsignedNumbers()) {
            tmp_0 = this.v2s_1;
          } else {
            var tmp0 = this.v2s_1.u2q_1;
            var p1 = this.b2t_1;
            tmp_0 = new (ComposerForUnsignedNumbers())(tmp0, p1);
          }
          var tmp$ret$0 = tmp_0;
          tmp = StreamingJsonEncoder().o2u(tmp$ret$0, this.w2s_1, this.x2s_1, null);
        } else if (get_isUnquotedLiteral(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_2;
          var tmp_3 = this.v2s_1;
          if (tmp_3 instanceof ComposerForUnquotedLiterals()) {
            tmp_2 = this.v2s_1;
          } else {
            var tmp0_0 = this.v2s_1.u2q_1;
            var p1_0 = this.b2t_1;
            tmp_2 = new (ComposerForUnquotedLiterals())(tmp0_0, p1_0);
          }
          var tmp$ret$2 = tmp_2;
          tmp = StreamingJsonEncoder().o2u(tmp$ret$2, this.w2s_1, this.x2s_1, null);
        } else if (!(this.c2t_1 == null)) {
          // Inline function 'kotlin.apply' call
          this.d2t_1 = descriptor.k1n();
          tmp = this;
        } else {
          tmp = super.f1s(descriptor);
        }
        return tmp;
      }
      u1r() {
        this.v2s_1.d2r('null');
      }
      v1r(value) {
        if (this.b2t_1) {
          this.d1s(value.toString());
        } else {
          this.v2s_1.m2r(value);
        }
      }
      w1r(value) {
        if (this.b2t_1) {
          this.d1s(value.toString());
        } else {
          this.v2s_1.h2r(value);
        }
      }
      x1r(value) {
        if (this.b2t_1) {
          this.d1s(value.toString());
        } else {
          this.v2s_1.j2r(value);
        }
      }
      y1r(value) {
        if (this.b2t_1) {
          this.d1s(value.toString());
        } else {
          this.v2s_1.k2r(value);
        }
      }
      z1r(value) {
        if (this.b2t_1) {
          this.d1s(value.toString());
        } else {
          this.v2s_1.l2r(value);
        }
      }
      a1s(value) {
        if (this.b2t_1) {
          this.d1s(value.toString());
        } else {
          this.v2s_1.f2r(value);
        }
        if (!this.a2t_1.x2n_1 && !isFinite(value)) {
          throw InvalidFloatingPointEncoded(value);
        }
      }
      b1s(value) {
        if (this.b2t_1) {
          this.d1s(value.toString());
        } else {
          this.v2s_1.g2r(value);
        }
        if (!this.a2t_1.x2n_1 && !isFinite_0(value)) {
          throw InvalidFloatingPointEncoded(value);
        }
      }
      c1s(value) {
        this.d1s(toString(value));
      }
      d1s(value) {
        return this.v2s_1.n2r(value);
      }
      e1s(enumDescriptor, index) {
        this.d1s(enumDescriptor.h1p(index));
      }
    }
    initMetadataForClass($, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder()]);
    StreamingJsonEncoderClass = $;
  }
  return StreamingJsonEncoderClass;
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.e1p() && get_unsignedNumberDescriptors().t2(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.e1p() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer(Companion_getInstance()).h1m(), serializer_0(Companion_getInstance_0()).h1m(), serializer_1(Companion_getInstance_1()).h1m(), serializer_2(Companion_getInstance_2()).h1m()]);
  }
}
//region block: exports
export {
  StreamingJsonEncoder as StreamingJsonEncoder1wswwd0g47gwe,
  get_isUnsignedNumber as get_isUnsignedNumber3dxwaa3af8ncr,
};
//endregion

//# sourceMappingURL=StreamingJsonEncoder.mjs.map
